import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface RotasOtimizadasModel {
}

interface RotasOtimizadasStore {
    pontosRotasPedidos: string[] | undefined;
    setPontosRotasPedidos: (pontosRotasPedidos: string[] | undefined) => void;
}

export const useRotasOtimizadasStore = create<RotasOtimizadasStore>()(
    persist(
        (set) => ({
            pontosRotasPedidos: undefined,
            setPontosRotasPedidos: (pontosRotasPedidos) => set(() => ({
                pontosRotasPedidos: pontosRotasPedidos
            }))
        }),
        {
            name: 'rotas-otimizadas-storage',
        }
    )
)
